import { Flex } from 'foundations-components/components/Flex';
import { CdpText } from '../../v2/ui/CdpText';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
import InvalidChangesTooltip from './InvalidChangesTooltip';
import { CdpButton } from '../../v2/ui/CdpButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ManualSaveAlert({
  invalidRequests,
  onSave,
  onCancel,
  requests
}) {
  const canSave = invalidRequests.length === 0;
  const colors = useMemo(() => {
    if (canSave) {
      return {
        borderColor: 'fill-info-default',
        backgroundColor: 'fill-info-subtle'
      };
    }
    return {
      borderColor: 'border-caution-default',
      backgroundColor: 'fill-caution-subtle'
    };
  }, [canSave]);
  if (requests.length === 0) {
    return null;
  }
  const validChangesCount = requests.reduce((acc, request) => acc + request.updates.properties.length, 0);
  return /*#__PURE__*/_jsxs(Flex, {
    "data-test-id": "manual-save-alert",
    alignItems: "center",
    backgroundColor: colors.backgroundColor,
    blockSize: "48px",
    borderColor: colors.borderColor,
    borderRadius: "100",
    borderStyle: "solid",
    borderWidth: "100",
    boxShadow: "100",
    gap: "400",
    inlineSize: "max-content",
    justifyContent: "center",
    paddingBlock: "0",
    paddingInline: "300",
    children: [/*#__PURE__*/_jsxs(CdpText, {
      typography: "heading-50",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.autosave.unsavedChanges",
        options: {
          count: validChangesCount
        },
        useGap: invalidRequests.length > 0
      }), invalidRequests.length > 0 && /*#__PURE__*/_jsx(InvalidChangesTooltip, {
        invalidRequests: invalidRequests,
        children: invalidChangesCount => /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "customerDataProperties.autosave.unsavedChangesIssues_jsx",
          options: {
            count: invalidChangesCount
          },
          elements: {
            UnderlineText: ({
              children
            }) => /*#__PURE__*/_jsx(CdpText, {
              as: "span",
              textDecoration: "underline",
              children: children
            })
          }
        })
      })]
    }), /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(CdpButton, {
        use: "tertiary",
        size: "extra-small",
        disabled: !canSave,
        onClick: onSave,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.autosave.save"
        })
      }), /*#__PURE__*/_jsx(CdpButton, {
        use: "tertiary-light",
        size: "extra-small",
        onClick: onCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.autosave.cancel"
        })
      })]
    })]
  });
}
export default ManualSaveAlert;